import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/activities/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_ID = NAMESPACE + 'SET_LAST_LOADED_ID'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET = NAMESPACE + 'SET'

const defaultCardState = {
  activities: [],
  activitiesById: {},
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false
}

const initialState = {}

const transformActvity = (activity) => {
  const _activity = {
    ...activity
  }

  if ((activity.data.action === 'EditCommentOnCard' ||
       activity.data.action === 'RemoveCommentFromCard') &&
       activity.data.originalTimestamp) {
    _activity.timestamp = activity.data.originalTimestamp
  }

  return _activity
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case SET_LAST_LOADED_ID:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          lastLoadedId: action.payload.lastLoadedId
        }
      } : undefined
    case ADD: {
      if (!state[action.payload.cardId]) return state

      const activity = transformActvity(action.payload.activity)

      return {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          activities: addUniqueValueToArray({
            array: state[action.payload.cardId].activities,
            value: activity.id,
            index: activity.index
          }),
          activitiesById: {
            ...state[action.payload.cardId].activitiesById,
            [activity.id]: {
              ...activity
            }
          }
        }
      }
    }
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          activities: [ ...state[action.payload.cardId].activities ],
          activitiesById: { ...state[action.payload.cardId].activitiesById },
        }
      }

      action.payload.array.forEach(activity => {
        activity = transformActvity(activity)
        newState[action.payload.cardId].activities = addUniqueValueToArray({
          array: newState[action.payload.cardId].activities,
          value: activity.id,
          index: activity.index
        })
        newState[action.payload.cardId].activitiesById[activity.id] = {
          ...activity
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.cardId] || !state[action.payload.cardId].activitiesById[action.payload.activityId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          activities: [ ...state[action.payload.cardId].activities.filter(id => id !== action.payload.activityId) ],
          activitiesById: { ...state[action.payload.cardId].activitiesById }
        }
      }

      delete newState[action.payload.cardId].activitiesById[action.payload.activityId]

      return newState
    }
    case SET:
      return state[action.payload.cardId] && state[action.payload.cardId].activitiesById[action.payload.activity.id] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          activitiesById: {
            ...state[action.payload.cardId].activitiesById,
            [action.payload.activity.id]: {
              ...state[action.payload.cardId].activitiesById[action.payload.activity.id],
              ...action.payload.activity
            }
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ cardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      cardId,
      isLoading,
      isLoaded,
    }
  }
}

export function setLastLoadedId ({ cardId, lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_ID,
    payload: {
      cardId,
      lastLoadedId,
    }
  }
}

export function add ({ cardId, activity }) {
  return {
    type: ADD,
    payload: {
      cardId,
      activity,
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array,
    }
  }
}

export function remove ({ cardId, activityId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      activityId,
    }
  }
}

export function set ({ cardId, activity }) {
  return {
    type: SET,
    payload: {
      cardId,
      activity,
    }
  }
}
